module.exports = __webpack_public_path__ + "img/Unidad19-5.66b870c6.png";